import { ViewTemplate, children, elements, html, repeat } from '@microsoft/fast-element';
import { Diagram } from './diagram.js';

import platformDiagram from '/images/platform-diagram.svg?raw';
import { staticallyCompose } from '@microsoft/fast-foundation';

type ItemData = {
	title: {
		text: string;
		highlighted: string;
	},
	content: ViewTemplate
}

const accordionItemsData: ItemData[] = [
	{
		title: {
			text: 'Transformation',
			highlighted: 'Digital'
		},
		content: html`Streamline complex workflows and eliminate manual processes using AI-driven automation, enabling faster deployment, reduced operational overhead, and quicker realization of ROI.`
	},
	{
		title: {
			text: 'Design Systems',
			highlighted: 'Adaptive'
		},
		content: html`Accelerate innovation with AI design systems, dedicated to creating delightful user experiences and polished interactions 3x faster than traditional UX/UI design processes.`
	},
	{
		title: {
			text: 'Excellence',
			highlighted: 'Operational'
		},
		content: html`Optimize people, processes, and products using high-efficiency systems that increase productivity and deliver daily software improvements.`
	},
	{
		title: {
			text: 'Proof-Technology',
			highlighted: 'Future'
		},
		content: html`Leverage advanced and emerging technologies to create reliable, maintainable, and scalable solutions that quickly render fluid user experiences.`
	},
	{
		title: {
			text: 'Compliance',
			highlighted: 'Embedded'
		},
		content: html`Integrate security, privacy, and accessibility at the core, increasing your defensive posture against modern-day risks.`
	},
	{
		title: {
			text: 'Analytics',
			highlighted: 'AI-Powered',
		},
		content: html`Autonomously retrieve relevant knowledge, predict outcomes, and execute decisions with context-aware, goal-driven intelligence.`
	}
]

export default html<Diagram>`
	<div class="image-container">
		${staticallyCompose(platformDiagram)}
	</div>
	<adaptive-accordion class="items-container" expand-mode="single" ${children({ property: 'items', filter: elements() })}>
		${repeat(accordionItemsData, html<ItemData>`
			<adaptive-accordion-item
				@mouseover=${(x, c) => c.parent.handleMouseover(c.index + 1)}
				@mouseout=${(x, c) => c.parent.handleMouseout(c.index + 1)}
				@expanded-change=${(x, c) => c.parent.handleExpanded(c.event, c.index + 1)}
			>
				<b slot="heading"><span class="highlighted">${x => x.title.highlighted}</span> ${x => x.title.text}</b>
				<p>
					${x => x.content}
				</p>
			</adaptive-accordion-item>
		`, { positioning: true })}
	</adaptive-accordion>
`;